import { render, staticRenderFns } from "./AssignDocumentOperation.vue?vue&type=template&id=6126cf4a&scoped=true&"
import script from "./AssignDocumentOperation.vue?vue&type=script&lang=js&"
export * from "./AssignDocumentOperation.vue?vue&type=script&lang=js&"
import style0 from "./AssignDocumentOperation.vue?vue&type=style&index=0&id=6126cf4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6126cf4a",
  null
  
)

export default component.exports